import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { ContactoPage } from '@/components/marketing/ContactoPage';

export const Route = createFileRoute('/_public/contacto')({
  component: () => (
    <MarketingShell currentPath="/contacto">
      <ContactoPage />
    </MarketingShell>
  ),
});
